/* eslint no-underscore-dangle: ["error", { "allow": ["_this"] }] */
import $ from 'jquery';
import autosize from '../helpers/autosize';

module.exports = {
  init() {
    const $postSubmit = $('#discussionPost-submit textarea');
    const $postReply = $('#discussionComment-replyBox textarea');
    autosize($postSubmit);
    autosize($postReply);

    console.log('ads js');
    $(document).on('click', '.discussionComment-replyLink', function (e) { // eslint-disable-line func-names
      e.preventDefault();
      const composer = $('.discussionComment-composer.discussionComment-composer--reply');
      const discussionPost = $('.discussionPost');
      let commentId;
      let commentAuthorId;
      if ($(this).data('commentId') !== undefined) {
        commentId = $(this).data('commentId');
      }

      if ($(this).data('commentAuthorId') !== undefined) {
        commentAuthorId = $(this).data('commentAuthorId');
      }

      discussionPost.find('.discussionComment-cancelLink').addClass('is-hidden');
      discussionPost.find('.discussionComment-replyLink').removeClass('is-hidden');
      discussionPost.addClass('mbm');

      composer.find('input[name="parent"]').val(commentId);
      composer.removeClass('mbm');
      composer.insertAfter($(this).closest('.discussionComment'));
      composer.find('textarea').val('');
      autosize.destroy(composer.find('textarea'));
      autosize(composer.find('textarea'));

      if (commentAuthorId !== undefined && commentAuthorId.length) {
        composer.find('textarea').val(`@${commentAuthorId} `).focus();
      }

      $(this).siblings('.discussionComment-cancelLink').removeClass('is-hidden');
      $(this).addClass('is-hidden');
    });

    $(document).on('click', '.discussionComment-cancelLink', function (e) { // eslint-disable-line func-names
      e.preventDefault();

      autosize.destroy($postReply);

      let composerSelector = '';
      if ($(this).data('composerSelector') !== 'undefined') {
        composerSelector = $(this).data('composerSelector');
      }
      const composer = $(composerSelector);
      const discussionPost = $('.discussionPost');

      discussionPost.find('.discussionComment-cancelLink').addClass('is-hidden');
      discussionPost.find('.cancelable').removeClass('is-hidden');
      discussionPost.removeClass('mbm');

      if (composer.hasClass('discussionComment-composer--edit')) {
        composer.addClass('is-hidden');
      } else {
        composer.insertAfter(discussionPost);
        composer.addClass('mbm');
        autosize.destroy(composer.find('textarea'));
        autosize(composer.find('textarea'));
      }
      composer.find('input[name="parent"]').val('');
      composer.find('textarea').val('');
    });
  },
};
